import React, { Component } from 'react';

import AdminLayout from './layout';


import { getSchoolDetail } from '../../API/FetchCall';
import { Col } from 'reactstrap';

class verticalSchoolDetail extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              schoolDetail:''
        };

        this.id = this.props.match.params.id ? this.props.match.params.id : '';
    }


    componentDidMount() {

      this.getSchool(this.id);

    }


    getSchool = () => {
      let ins = JSON.stringify({
        id:this.id
      });
      getSchoolDetail(ins).then((res) => {
        if (res.status === 1) {
          this.setState({
            schoolDetail: res.data
            
          });
        } else {
          this.setState({
            schoolDetail: '',
          });
        }
      });
    }   


     
  gallery_image() {

    let photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
    let rows = "";
    if (photos.length > 0) {
      rows = photos.map((photos) => {
        if (photos.name){
          return (
            <div class="col-md-4 float-left mt-4 p-0">
              <img src={this.state.url + photos.name} alt="Img" class="img-thumbnail" />
            </div>
          );
        }
        return;
      });
    } else {
      rows = "";
    }
    return rows;

  }

    render() {

        const { schoolDetail } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">{schoolDetail.organisation_name} - View</h4>
                                   
                  <div class="pt-3 detailsection">
                        

                      <div className="box-shadow-custom">
                        <div className="row">

                        <div className="col-md-12 col-xs-12">
                            <span className="form-legend bottom-bordered">
                              <h3>Primary Information</h3>
                            </span>
                          </div>

                          <div className="form-group col-md-4">
                            <label>
                              Registration No
                            </label>
                            <p>{schoolDetail.registration_no}</p>

                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Owner Name
                            </label>
                            <p>{schoolDetail.ownerName}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Organization Name
                            </label>
                            <p>{schoolDetail.schoolName}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Type of School
                            </label>
                            <p>{schoolDetail.sub_cate_boe}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Board of Education
                            </label>
                            <p>{schoolDetail.sub_types_names}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Campus Type
                            </label>
                            <p>{schoolDetail.sub_type_names}</p>
                          </div>

                        </div>
                      </div>

                      
                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">
                              <h3>Address Information</h3>
                            </span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Email Id
                            </label>
                            <p>{schoolDetail.email_id}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Phone Number
                            </label>
                            <p>{schoolDetail.phone_number}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Landline Number
                            </label>
                            <p>{schoolDetail.landline_number}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>
                              Website
                            </label>
                            <p>{schoolDetail.website}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              State
                            </label>
                            <p>{schoolDetail.state}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Location
                            </label>
                            <p>{schoolDetail.location}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Country
                            </label>
                            <p>{schoolDetail.country}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Pincode
                            </label>
                            <p>{schoolDetail.pincode}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Address
                            </label>
                            <p>{schoolDetail.address}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>
                              Google Location Address
                            </label>
                            <p>{schoolDetail.google_location}</p>
                          </div>
                          <div className="form-group col-md-12">
                            <label>
                              About the School
                            </label>
                            <div dangerouslySetInnerHTML={{__html:schoolDetail.about_school}}></div>
                          </div>
                        </div>
                      </div>


                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend"><h3>Key Information</h3></span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              School type
                            </label>
                            <p>{schoolDetail.scltype}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Classification
                            </label>
                            <p>{schoolDetail.cls_name}</p>
                          </div>
                          <div className="form-group col-md-4 input-group-cus">
                            <div>
                              <label>Grade From/ To</label>
                              <p>{schoolDetail.grade}</p>
                            </div>
                            <div>
                              <label>&nbsp;</label>
                              <p>{schoolDetail.grade_to}</p>
                            </div>
                          </div>



                          <div className="form-group col-md-4 input-group-cus">
                            <div>
                              <label>From Timing</label>
                              <p>{schoolDetail.dfrom_time}</p>
                            </div>
                          </div>

                          <div className="form-group col-md-4 input-group-cus">
                            <div>
                              <label>To Timing</label>
                              <p>{schoolDetail.dto_time}</p>
                            </div>
                          </div>

                          <div className="form-group col-md-4">
                            <label>Min Age of Admission</label>
                            <p>{schoolDetail.min_age}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Instruction Language</label>
                            <p>{schoolDetail.instruction_lang}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Student Ratio</label>
                            <p>{schoolDetail.teacher_student_ratio}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Establishment Year
                            </label>
                            <p>{schoolDetail.establishment_Year}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Amenities </label>
                            <p>{schoolDetail.facilites}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Indicative Annual Fee(INR)
                            </label>
                            <p>{schoolDetail.avg_anual_fee}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Other Fees
                            </label>
                            <p>{schoolDetail.other_fee}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Admission Fees
                            </label>
                            <p>{schoolDetail.addmission_fee}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Is Refundable (Admission Fees)
                            </label>
                            <p>{(schoolDetail.is_refund === 1) ? 'Yes' : 'No'}</p>

                          </div>
                        </div>
                      </div>

                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">
                              Admission Details
                            </span>

                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Admission Link
                            </label>
                            <p>{schoolDetail.admission_link}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Application Fees
                            </label>
                            <p>{schoolDetail.processing_fee}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Required Documents </label>
                            <p>{schoolDetail.document_name}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Admission Process</label>
                            <p>{schoolDetail.admission_process}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>Website Search Keywords</label>
                            <p>{schoolDetail.keywords}</p>
                          </div>
                        </div>
                      </div>
                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">Images</span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Banner Images
                            </label>
                            {schoolDetail.images &&
                              <img src={schoolDetail.url + schoolDetail.images} alt="Img" class="img-thumbnail" />
                            }

                          </div>




                          <div class="col-md-12 float-left mt-4 p-0">
                            <label>
                              Gallery Images
                            </label>
                          </div>


                          {this.gallery_image()}

                        </div>
                      </div>

                        <Col className='' md='12'>
                          <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleSubmit}>
                            {this.state.edited && this.state.role === 1 ? 'Approve' : 'Submit'}
                          </button>
                          {this.state.edited && this.state.role === 1 && (
                            <button className='btn btn-sm btn-danger custome-submit' style={{ marginLeft: '10px' }}
                              onClick={this.handleReject}>
                              Reject
                            </button>
                          )}
                          <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                            onClick={() => { this.setState({ preview: false }) }}>Close</button>
                        </Col>

                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default verticalSchoolDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalSchoolDetail.jsx